<template>
    <div class="successlogin">
    </div>
</template>

<script>
import { Base64 } from 'js-base64';
import utf8 from 'utf8';

export default {
  async created() {
    const tokenDecode = Base64.decode(this.$route.params.token);
    const token = utf8.decode(tokenDecode);
    await this.$cookies.set('accessToken', token);
    if(localStorage.getItem('redirectUrl')) {
      const url = localStorage.getItem('redirectUrl');
      localStorage.removeItem('redirectUrl');
      // this.$router.push(url);
      location.href = url
    } else {
      // this.$router.push('/');
      location.href = '/'
    }
    // eslint-disable-next-line no-restricted-globals
    // location.reload();
  },
};
</script>
